import GalleryGridContainer from "../../../../Component/Miscellaneous/Gallery/GalleryGrid/GalleryGrid"

const GalleryGrid = () => {
  return (
    <div className='page-body'>
      <GalleryGridContainer />
    </div>
  )
}

export default GalleryGrid